import { posthog } from "posthog-js";

/**
 * Custom PostHog event names. Kebab-case to match the existing
 * `signup-complete` event. Keep this list as the single source of truth so
 * event names stay consistent across the app and are easy to find when
 * building insights/funnels in PostHog.
 */
export const EVENTS = {
  // Book submission funnel (memories list -> wizard -> review -> thank you)
  BOOK_WIZARD_STARTED: "book-wizard-started",
  BOOK_WIZARD_STEP_COMPLETED: "book-wizard-step-completed",
  MEMORIES_SELECT_ALL_TOGGLED: "memories-select-all-toggled",
  BOOK_SUBMIT_STARTED: "book-submit-started",
  PARTIAL_SELECTION_CONFIRMED: "partial-selection-confirmed",
  BOOK_SUBMISSION_CONSENT_COMPLETED: "book-submission-consent-completed",
  BOOK_SUBMITTED: "book-submitted",
  BOOK_THANK_YOU_VIEWED: "book-thank-you-viewed",

  // Chapter management
  CHAPTERS_REORDERED: "chapters-reordered",
  CHAPTER_DELETED: "chapter-deleted",
};

/**
 * Fire a custom PostHog event. Wrapped so a misbehaving analytics call can
 * never break a user flow.
 *
 * @param {string} event one of EVENTS
 * @param {Record<string, unknown>} [props] event properties
 */
export const track = (event, props = {}) => {
  try {
    posthog.capture(event, props);
  } catch (e) {
    // swallow — analytics must never interrupt the app
  }
};
